import { z } from 'zod'
import { PASSWORD_RULES } from '@/shared/constants/password'

export function isStrongPassword(value: string): boolean {
  return PASSWORD_RULES.every((rule) => rule.isMet(value))
}

export const tenantAdminCreateSchema = z
  .object({
    fullName: z.string().trim().optional(),
    email: z.string().trim().email('common.invalidEmail').or(z.literal('')).optional(),
    username: z.string().trim().min(3, 'user.validation.usernameMin'),
    password: z.string().refine(isStrongPassword, 'tenant.admin.validation.passwordPolicy'),
    confirmPassword: z.string().min(1, 'common.required'),
  })
  .refine((values) => values.password === values.confirmPassword, {
    path: ['confirmPassword'],
    message: 'tenant.admin.validation.passwordMismatch',
  })

export type TenantAdminCreateValues = z.infer<typeof tenantAdminCreateSchema>

export const tenantAdminPasswordSchema = z
  .object({
    password: z.string().refine(isStrongPassword, 'tenant.admin.validation.passwordPolicy'),
    confirmPassword: z.string().min(1, 'common.required'),
  })
  .refine((values) => values.password === values.confirmPassword, {
    path: ['confirmPassword'],
    message: 'tenant.admin.validation.passwordMismatch',
  })

export type TenantAdminPasswordValues = z.infer<typeof tenantAdminPasswordSchema>
